import { render, staticRenderFns } from "./RelatedArticle.vue?vue&type=template&id=c758437e&"
import script from "./RelatedArticle.vue?vue&type=script&lang=js&"
export * from "./RelatedArticle.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticle.vue?vue&type=style&index=0&id=c758437e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports